import { StoreFactories } from "@com.mgmtp.a12.client/client-core";
import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { createEventButtonActionMatcher } from "../../../utilities/actionUtils";

import { InvitationModalDescriptor } from "../descriptors";
import { isInvitationDocumentData } from "../types";

const actionMatcher = createEventButtonActionMatcher("event_cancel");
export const cleanIsDirtyOnCancelMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	if (!actionMatcher(action)) {
		return next(action);
	}
	const { activityId } = action.payload;
	const activity = ActivitySelectors.activityById(activityId)(api.getState());
	if (!InvitationModalDescriptor.isInstance(activity?.descriptor)) {
		return next(action);
	}
	const data = ActivitySelectors.data(activityId)(api.getState());
	if (!isInvitationDocumentData(data) || data.document.root.newInvitations.recipients?.length !== 0) {
		return next(action);
	}
	api.dispatch(ActivityActions.setDirty({ activityId, dirty: false }));
	return next(action);
});
